import React, { ReactElement } from 'react';

// Components
import TagsSearchBar from './TagsSearchBar';
import TagsCreateButtons from './TagsCreateButtons';
import TagsList from './TagsList';

// Utils
import { TagsToolbarPopupProps } from './popup/TagsToolbarPopup';
import useTagContentState from './useTagContentState';

// Types
import { Tag } from '../../../../../../common/tags/tagTypes';

import './TagsToolContent.scss';

type TagsToolContentProps = TagsToolbarPopupProps & {
    handleClickEdit: (tag: Tag) => void;
};

const TagsToolContent = (props: TagsToolContentProps): ReactElement => {
    const { currentBoardId, handleClickEdit, shareRootPath, userRootPath, selectedElements } = props;

    const {
        searchString,
        setSearchString,
        selectedTags,
        unselectedTags,
        handleClickSelectedTag,
        handleAddTagToElement,
        fetchCurrentContextTags,
    } = useTagContentState(currentBoardId, userRootPath, selectedElements);

    return (
        <div className="TagsToolContent">
            <TagsSearchBar value={searchString} onChange={setSearchString} />
            <TagsList
                tagsArray={selectedTags}
                handleClickTag={handleClickSelectedTag}
                handleClickEdit={handleClickEdit}
                isSelected
            />
            <TagsList
                tagsArray={unselectedTags}
                handleClickTag={handleAddTagToElement}
                handleClickEdit={handleClickEdit}
            />
            {searchString && (
                <TagsCreateButtons
                    {...props}
                    shareRootPath={shareRootPath}
                    searchString={searchString}
                    setSearchString={setSearchString}
                    fetchTags={fetchCurrentContextTags}
                />
            )}
        </div>
    );
};

export default TagsToolContent;
